var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_FILL0_wght300_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.72586 14.314C7.16048 14.314 5.83485 13.7711 4.74897 12.6852C3.66307 11.5993 3.12012 10.2737 3.12012 8.70828C3.12012 7.1429 3.66307 5.81726 4.74897 4.73136C5.83485 3.64548 7.16048 3.10254 8.72586 3.10254C10.2912 3.10254 11.6169 3.64548 12.7028 4.73136C13.7887 5.81726 14.3316 7.1429 14.3316 8.70828C14.3316 9.36287 14.2217 9.98808 14.002 10.5839C13.7822 11.1797 13.489 11.698 13.1223 12.1387L18.3967 17.4131C18.5236 17.54 18.5885 17.6995 18.5915 17.8917C18.5944 18.0838 18.5295 18.2463 18.3967 18.3791C18.2639 18.5119 18.1029 18.5783 17.9137 18.5783C17.7245 18.5783 17.5635 18.5119 17.4307 18.3791L12.1563 13.1047C11.698 13.4831 11.1709 13.7793 10.575 13.9932C9.97921 14.2071 9.36282 14.314 8.72586 14.314ZM8.72586 12.9391C9.90695 12.9391 10.9074 12.5292 11.7271 11.7095C12.5468 10.8898 12.9566 9.88937 12.9566 8.70828C12.9566 7.52718 12.5468 6.52678 11.7271 5.70707C10.9074 4.88735 9.90695 4.47749 8.72586 4.47749C7.54476 4.47749 6.54436 4.88735 5.72464 5.70707C4.90494 6.52678 4.49509 7.52718 4.49509 8.70828C4.49509 9.88937 4.90494 10.8898 5.72464 11.7095C6.54436 12.5292 7.54476 12.9391 8.72586 12.9391Z",
    fill: "#333236"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9d44ceabd722a15019504f0c3f74c549.svg";
export { ForwardRef as ReactComponent };